import { Button, Divider, Form, Input, message, Select, Switch } from "antd";
import { useContext } from "react";
import { Context } from "../context/context";
import { useState } from "react";
import { User } from "../requests/requests";

export default function EnableDisableKcUsers() {
  const { api, message } = useContext(Context);
  const [ids, setIds] = useState<string[]>([]);
  const [type, setType] = useState<'pmId' | 'fhirId' | 'email'>('pmId');
  const [enable, setEnable] = useState<boolean>(false);

  async function enableDisableUsers() {
    if (!api) return;
    try {
      const result = await api.usersEnable({ ids, type, enable });
      console.log('enableDisableUsers result', result);
      const errors = result.map((r: any) => r.error ? `${r.source_id}: ${r.error}` : null).filter((e: any) => e !== null);

      message(`${result.length - errors.length} users ${enable ? 'enabled' : 'disabled'} with ${errors.length} errors (${errors.join(', ')})`, 'success');
    } catch (error: any) {
      message(error.response.data.message || error.toString(), 'error');
    }
  }
  return <>
    <Divider><h4>Enable/Disable Keycloak Users</h4></Divider>
    <Form onFinish={enableDisableUsers}>
      <div style={{ display: 'flex', gap: 20, alignItems: 'end' }}>
        <Form.Item label="Type" name="type" required>
          <Select style={{ width: 90 }}
            options={[{ label: 'pmId', value: 'pmId' }, { label: 'fhirId', value: 'fhirId' }, { label: 'email', value: 'email' }]}
            onChange={(value) => setType(value as 'pmId' | 'fhirId' | 'email')}
          />
        </Form.Item>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <span style={{ fontSize: '12px' }}> (comma separated list of ids)</span>
          <Form.Item label="Ids" name="ids" required>
            <Input style={{ width: 300 }} onChange={(e) => setIds(e.target.value.split(',').map((id: string) => id.trim()))} />
          </Form.Item>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 20 }}>
        <Form.Item label="Enable" name="enable" required>
          <Switch checked={enable} onChange={(checked) => setEnable(checked)} />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary">
            Submit
          </Button>
        </Form.Item>
      </div>
    </Form>

  </>
}